<template>
        <b-img-lazy v-if="imageData"
               v-bind="mainProps"
               fluid
               :src="imageData"
               :rounded="rounded"/>
</template>

<script>
    import FairApi from "../modules/api";

    export default {
        name: 'fair-image',
        props: {
            imageId: {
                type: [String, Number],
                default: null
            },
            defaultUrl: {
                type: String,
                default: null
            },
            rounded:{
                type: String,
                default: null
            },
        },
        data() {
            return {
                imageData: null,
                mainProps: {
                    blank: true,
                    blankColor: '#FFF'
                }
            }
        },
        created: function () {
            this.imageData = this.defaultUrl
            this.getImage()
        },
        watch: {
            defaultUrl: function () {
                this.imageData = this.defaultUrl
            }
        },
        methods: {
            getImage() {
                if (this.imageId) {
                    FairApi.get(FairApi.photo(this.imageId), this.success, function () {
                    })
                }
            },
            success(response) {
                this.imageData = response
                this.$emit('onLoaded')
            }
        }
    }
</script>
